import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';

const StaffingRequestToolbarHeading = ({
  selectedCount,
  canShowEgm,
  egmDetails,
  onOpenUpdateStatus,
  onCheckEgm,
  onOpenNewRequest,
  canOpenNewRequest,
  filterButtonSlotRef,
  hasAccess,
  hasApprovalAccess,
}) => (
  <div className="sr-toolbar-heading">
    <div className="sr-toolbar-heading__top-row">
      <h3 className="sr-toolbar-heading__title">Staffing Request</h3>
      <div className="sr-toolbar-heading__actions">
        {(hasApprovalAccess('update') || hasApprovalAccess('edit')) && (
          <>
            <span className="sr-toolbar-heading__selected-text">
              No. of Staffing request selected : {selectedCount}
            </span>
            <Tooltip
              title={selectedCount === 0 ? 'Select rows to update status' : 'Update status for selected rows'}
              arrow
              placement="top"
              classes={{ tooltip: 'sr-tooltip', arrow: 'sr-tooltip__arrow' }}
            >
              {/* span wrapper lets Tooltip show even when the button is disabled */}
              <span>
                <button
                  type="button"
                  className="sr-link-button sr-update-link"
                  onClick={onOpenUpdateStatus}
                  disabled={selectedCount === 0}
                >
                  Update Status
                </button>
              </span>
            </Tooltip>
          </>
        )}
        <div
          className="sr-toolbar-heading__filter-slot"
          ref={filterButtonSlotRef}
        />
        {(hasAccess('create') || hasApprovalAccess('add')) && (
          <Tooltip
            title={canOpenNewRequest ? 'New Request' : 'Select single Project and apply filters to create new requests'}
            arrow
            placement="top"
            classes={{ tooltip: 'sr-tooltip', arrow: 'sr-tooltip__arrow' }}
          >
            {/* span wrapper lets Tooltip show even when the button is disabled */}
            <span>
              <button
                type="button"
                className="sr-icon-btn"
                onClick={onOpenNewRequest}
                aria-label="New Request"
                disabled={!canOpenNewRequest}
              >
                <AddIcon fontSize="small" />
              </button>
            </span>
          </Tooltip>
        )}
      </div>
    </div>

    <div className="sr-toolbar-heading__bottom-row">
      {canShowEgm ? (
        <>
          <button
            type="button"
            className="sr-link-button"
            disabled={!selectedCount}
            onClick={onCheckEgm}
          >
            Show EGM
          </button>
          <div className="sr-egm-panel">
            <p>Current EGM: {egmDetails.currentEgm}</p>
            <p>Projected EGM: {egmDetails.projectedEgm}</p>
            <p>EGM Variation: {egmDetails.egmVariation}</p>
            <p>Pending Future Effort: {egmDetails.pendingFutureEffort}</p>
            <p>Expected Future Cost: {egmDetails.expectedFutureCost}</p>
            <p>Estimated Cost: {egmDetails.estimatedCost}</p>
            <p>Estimated Profit: {egmDetails.estimatedProfit}</p>
            <p>Estimated Revenue: {egmDetails.estimatedRevenue}</p>
          </div>
        </>
      ) : null}
    </div>
  </div>
);

StaffingRequestToolbarHeading.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  canShowEgm: PropTypes.bool.isRequired,
  egmDetails: PropTypes.shape({
    currentEgm: PropTypes.number,
    projectedEgm: PropTypes.number,
    egmVariation: PropTypes.number,
    pendingFutureEffort: PropTypes.number,
    expectedFutureCost: PropTypes.number,
    estimatedCost: PropTypes.number,
    estimatedProfit: PropTypes.number,
    estimatedRevenue: PropTypes.number,
  }).isRequired,
  onOpenUpdateStatus: PropTypes.func.isRequired,
  onCheckEgm: PropTypes.func.isRequired,
  onOpenNewRequest: PropTypes.func.isRequired,
  canOpenNewRequest: PropTypes.bool.isRequired,
  filterButtonSlotRef: PropTypes.shape({
    current: PropTypes.any,
  }),
  userInfo: PropTypes.shape({
    access_token: PropTypes.string,
    email: PropTypes.string,
    permissions: PropTypes.shape({}),
    roleDetails: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.shape({})]),
    employeeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    siteConfiguration: PropTypes.shape({
      global_colors: PropTypes.shape({}),
    }),
  }),
  hasAccess: PropTypes.func.isRequired,
  hasApprovalAccess: PropTypes.func.isRequired,
};

export default StaffingRequestToolbarHeading;
